// Заявление об окончании ИП после внесудебного банкротства (МФЦ), 03.11.2026.
// Вставка ФССП здесь только разбирается для документа — в таблицу ФССП, кредиторов и задачи ничего не пишется.
import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import api from '../utils/api';
import { parseFssp } from '../utils/fssp';
import { declineFio } from '../utils/declension';

// Отдел приставов из вставки — варианты дописывать, не заменять
const OSP_RE = [
  /((?:[А-ЯЁ][А-ЯЁа-яё\-]*\s+){0,6}(?:М?Р?ОСП|отдел судебных приставов)[^\n]{0,120}?(?:ГУФССП|УФССП)[^\n]{0,30}?по\s+(?:Республике\s+[А-ЯЁ][а-яё]+|[А-ЯЁ][а-яё]+\s+(?:области|краю)|г\.\s*[А-ЯЁ][а-яё]+|РБ))/i,
];
const findOsp = text => { for (const re of OSP_RE) { const m = text.match(re); if (m) return m[1].replace(/\s+/g, ' ').trim(); } return ''; };

// «ГИРФАНОВА Ю. А.» → «Гирфановой Ю. А.» (творительный, для «судебным приставом-исполнителем …»)
function bailiffIns(raw) {
  const m = String(raw || '').trim().match(/^([А-ЯЁа-яё\-]+)\s+(.+)$/);
  if (!m) return '';
  let s = m[1][0].toUpperCase() + m[1].slice(1).toLowerCase();
  if (/(ова|ева|ёва|ина|ына)$/.test(s)) s = s.slice(0, -1) + 'ой';
  else if (/(ская|цкая)$/.test(s)) s = s.slice(0, -2) + 'ой';
  else if (/(ов|ев|ёв|ин|ын)$/.test(s)) s = s + 'ым';
  else if (/(ский|цкий)$/.test(s)) s = s.slice(0, -2) + 'им';
  return `${s} ${m[2]}`;
}

const today = () => new Date().toISOString().slice(0, 10);

export default function IpEndMfcModal({ client, onClose, showToast }) {
  const fio = declineFio(client.last_name || '', client.first_name || '', client.middle_name || '');
  const initials = [client.first_name, client.middle_name].filter(Boolean).map(s => s[0] + '.').join(' ');
  const [paste, setPaste] = useState('');
  const [ips, setIps] = useState([]);
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({
    osp: '', debtor_gen: fio.gen, debtor_short: `${fio.gen.split(' ')[0] || ''} ${initials}`.trim(),
    debtor_short_nom: `${client.last_name || ''} ${initials}`.trim(),
    phone: ((client.phone || '').match(/[+\d][\d\s()-]{9,}\d/) || [''])[0].replace(/[\s()-]/g, ''),
    start_no: '', start_date: '', end_no: '', end_date: '', sign_date: today(),
  });
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  useEffect(() => {
    api.get(`/ip-end-mfc/${client.id}/prefill`).then(r => setF(p => ({
      ...p, start_no: p.start_no || r.data.start_no, start_date: p.start_date || r.data.start_date,
      end_no: p.end_no || r.data.end_no, end_date: p.end_date || r.data.end_date,
    }))).catch(() => {});
  }, [client.id]);

  const onPaste = text => {
    setPaste(text);
    const recs = parseFssp(text);
    setIps(recs.map(r => ({ ...r, on: !r.close_status, bailiff_ins: bailiffIns(r.bailiff) })));
    const osp = findOsp(text);
    if (osp) setF(p => (p.osp ? p : { ...p, osp }));
  };
  const toggle = (i, k, v) => setIps(list => list.map((x, j) => (j === i ? { ...x, [k]: v } : x)));

  const generate = async () => {
    const chosen = ips.filter(x => x.on);
    if (!chosen.length) { showToast('Отметьте хотя бы одно ИП', 'error'); return; }
    if (!f.osp.trim()) { showToast('Укажите отдел приставов', 'error'); return; }
    if (!f.start_no || !f.start_date || !f.end_no || !f.end_date) { showToast('Заполните номера и даты сообщений ЕФРСБ', 'error'); return; }
    setBusy(true);
    try {
      const resp = await api.post(`/ip-end-mfc/${client.id}`, { ...f, ips: chosen }, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const a = document.createElement('a'); a.href = url; a.download = `Окончание_ИП_МФЦ_${client.last_name || client.name}.docx`;
      a.click(); window.URL.revokeObjectURL(url);
      showToast('Заявление сформировано и сохранено в документы'); onClose();
    } catch { showToast('Не удалось сформировать заявление', 'error'); }
    setBusy(false);
  };

  const inp = (k, label, type = 'text') => (
    <div className="form-group" style={{ flex: 1, minWidth: 140 }}><label className="form-label">{label}</label>
      <input className="form-input" type={type} value={f[k]} onChange={e => set(k, e.target.value)} /></div>);

  return (
    <Modal title="Окончание ИП после банкротства через МФЦ" onClose={onClose}
      footer={<><button className="btn btn-secondary" onClick={onClose}>Отмена</button>
        <button className="btn btn-primary" onClick={generate} disabled={busy}>Сформировать Word</button></>}>
      <div className="form-group"><label className="form-label">Вставка с сайта ФССП (в карточку не сохраняется)</label>
        <textarea className="form-input" rows={5} value={paste} onChange={e => onPaste(e.target.value)} placeholder="Скопируйте результаты поиска на fssp.gov.ru и вставьте сюда" /></div>
      {paste && !ips.length && <div style={{ color: 'var(--danger, #c00)', marginBottom: 8 }}>ИП во вставке не найдены</div>}
      {ips.length > 0 && <div style={{ marginBottom: 12 }}>
        <div className="form-label">Исполнительные производства (оконченные сняты; включайте только долги, указанные в заявлении в МФЦ)</div>
        {ips.map((x, i) => (
          <div key={x.ip_number} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '4px 0', borderBottom: '1px solid var(--border, #eee)', flexWrap: 'wrap', opacity: x.on ? 1 : 0.55 }}>
            <input type="checkbox" checked={x.on} onChange={e => toggle(i, 'on', e.target.checked)} />
            <div style={{ flex: 2, minWidth: 200, fontSize: 13 }}>
              <b>{x.ip_number}</b> от {x.ip_date ? x.ip_date.split('-').reverse().join('.') : '—'}
              {x.close_status && <span style={{ color: '#a60', marginLeft: 6 }}>окончено {x.close_status}</span>}
              <div style={{ color: 'var(--text-secondary, #666)' }}>{x.court_act || 'документ не распознан'}</div>
            </div>
            <input className="form-input" style={{ flex: 1, minWidth: 140 }} placeholder="пристав (кем)" value={x.bailiff_ins} onChange={e => toggle(i, 'bailiff_ins', e.target.value)} />
          </div>))}
      </div>}
      <div className="form-group"><label className="form-label">Отдел приставов (кому)</label>
        <textarea className="form-input" rows={2} value={f.osp} onChange={e => set('osp', e.target.value)} />
        <button type="button" className="btn btn-secondary btn-sm" style={{ marginTop: 4 }} onClick={() => set('osp', 'ОСП по городу Белорецку и\nБелорецкому району ГУФССП по РБ')}>Белорецк</button></div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {inp('start_no', '№ сообщения о возбуждении')}{inp('start_date', 'от', 'date')}
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {inp('end_no', '№ сообщения о завершении')}{inp('end_date', 'от', 'date')}
      </div>
      {inp('debtor_gen', 'ФИО — от кого (родительный)')}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {inp('debtor_short', 'с кого (Ивановой И. И.)')}{inp('debtor_short_nom', 'подпись (Иванова И. И.)')}
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {inp('phone', 'Телефон')}{inp('sign_date', 'Дата заявления', 'date')}
      </div>
    </Modal>
  );
}
